import { initi18n } from '../i18n'

export const SHOP_ROOT_PATH = '/'
export const ORIGINE_PATH = '/products/la-couche-origine'
export const SHOP_COUCHE_PATH = '/pages/shop-couche'
export const BAB_ROOT_PATH = initi18n().t('shared:iconicUrl')

// # HARDCODED

export const JOONE_CHARGE_URL = document.querySelector(
  'meta[name="joone-charge-url"]'
).content

export const STEPS_DATA = [
  {
    id: 'bundle',
    index: 0,
    path: `${BAB_ROOT_PATH}/bundle`,
    translationKeys: {}
  },
  {
    id: 'size',
    index: 1,
    path: `${BAB_ROOT_PATH}/size`,
    translationKeys: {}
  },
  {
    id: 'pattern',
    index: 2,
    path: `${BAB_ROOT_PATH}/pattern`,
    translationKeys: {}
  },
  {
    id: 'upsell',
    index: 3,
    path: `${BAB_ROOT_PATH}/upsell`,
    translationKeys: {}
  }
]

export const BUNDLE_STEP = STEPS_DATA[0]
export const SIZE_STEP = STEPS_DATA[1]
export const PATTERN_STEP = STEPS_DATA[2]
export const UPSELL_STEP = STEPS_DATA[3]

export const PRODUCT_TYPES_DATA = [
  {
    id: 'diapers',
    skuPart: 'S',
    sizes: ['d1', 'd2', 'd3', 'd4', 'd5', 'd6'],
    patterns: [
      'malo',
      'brigitte',
      'blanc',
      'william',
      'andrea',
      'odette',
      'barbara',
      'bernard',
      'leon',
      'gabriel',
      'marceau',
      'edmond',
      'oscar',
      'tribudenoel',
      'benoit',
      'minischampions',
      'gaston'
    ],
    translationKeys: {
      name: 'productTypes.diapers.name',
      lowerCaseName: 'productTypes.diapers.lowerCaseName',
      singularName: 'productTypes.diapers.singularName'
    }
  },
  {
    id: 'pants',
    skuPart: 'S.CC',
    sizes: ['p4', 'p5', 'p6'],
    patterns: ['malo', 'brigitte', 'barbara', 'bernard'],
    translationKeys: {
      name: 'productTypes.pants.name',
      lowerCaseName: 'productTypes.pants.lowerCaseName',
      singularName: 'productTypes.pants.singularName'
    }
  }
]

export const DIAPERS_PRODUCT_TYPE = PRODUCT_TYPES_DATA[0]
export const PANTS_PRODUCT_TYPE = PRODUCT_TYPES_DATA[1]

export const BUNDLES_DATA = [
  {
    id: 'diapers',
    skuPart: 'JOONECHARGE.BUNDLE.C{upgradeData}.V1',
    basePrice: 64.9,
    productTypes: {
      diapers: 3
    },
    imageSources: {
      bundle:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_odette_en_situation.png'
    },
    translationKeys: {
      bundleName: 'Couches',
      imageAlt: "L'abonnement couches Joone"
    }
  },
  {
    id: 'pants',
    skuPart: 'JOONECHARGE.BUNDLE.CC{upgradeData}.V1',
    basePrice: 64.9,
    productTypes: {
      pants: 4
    },
    imageSources: {
      bundle:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_odette_en_situation.png'
    },
    translationKeys: {
      bundleName: 'Couches-Culottes',
      imageAlt: "L'abonnement couches-culottes Joone"
    }
  },
  {
    id: 'mix',
    skuPart: 'JOONECHARGE.BUNDLE.CC{upgradeData}.C.V1',
    basePrice: 64.9,
    productTypes: {
      diapers: 1,
      pants: 3
    },
    imageSources: {
      bundle:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_odette_en_situation.png'
    },
    translationKeys: {
      bundleName: 'Mix Couches et Couches-culottes',
      imageAlt: "L'abonnement mixte Joone"
    }
  }
]

export const DIAPERS_BUNDLE = BUNDLES_DATA[0]
export const PANTS_BUNDLE = BUNDLES_DATA[1]
export const MIX_BUNDLE = BUNDLES_DATA[2]

export const SIZES_DATA = [
  {
    id: 'd1',
    skuPart: 'T1',
    weightRange: [2, 4],
    quantityPerPack: 60,
    translationKeys: {
      shortHand: 'productSizes.d1.shortHand',
      lowerCaseName: 'productSizes.d1.lowerCaseName'
    }
  },
  {
    id: 'd2',
    skuPart: 'T2',
    weightRange: [3, 5],
    quantityPerPack: 64,
    translationKeys: {
      shortHand: 'productSizes.d2.shortHand',
      lowerCaseName: 'productSizes.d2.lowerCaseName'
    }
  },
  {
    id: 'd3',
    skuPart: 'T3',
    weightRange: [4, 8],
    quantityPerPack: 54,
    translationKeys: {
      shortHand: 'productSizes.d3.shortHand',
      lowerCaseName: 'productSizes.d3.lowerCaseName'
    }
  },
  {
    id: 'd4',
    skuPart: 'T4',
    weightRange: [7, 14],
    quantityPerPack: 48,
    translationKeys: {
      shortHand: 'productSizes.d4.shortHand',
      lowerCaseName: 'productSizes.d4.lowerCaseName'
    }
  },
  {
    id: 'd5',
    skuPart: 'T5',
    weightRange: [10, 18],
    quantityPerPack: 40,
    translationKeys: {
      shortHand: 'productSizes.d5.shortHand',
      lowerCaseName: 'productSizes.d5.lowerCaseName'
    }
  },
  {
    id: 'd6',
    skuPart: 'T6',
    weightRange: [16, 30],
    quantityPerPack: 38,
    pricePerUnit: 0.56,
    translationKeys: {
      shortHand: 'productSizes.d6.shortHand',
      lowerCaseName: 'productSizes.d6.lowerCaseName'
    }
  },
  {
    id: 'p4',
    skuPart: 'T4',
    weightRange: [8, 14],
    quantityPerPack: 30,
    translationKeys: {
      shortHand: 'productSizes.p4.shortHand',
      lowerCaseName: 'productSizes.p4.lowerCaseName'
    }
  },
  {
    id: 'p5',
    skuPart: 'T5',
    weightRange: [12, 18],
    quantityPerPack: 28,
    translationKeys: {
      shortHand: 'productSizes.p5.shortHand',
      lowerCaseName: 'productSizes.p5.lowerCaseName'
    }
  },
  {
    id: 'p6',
    skuPart: 'T6',
    weightRange: [16, 30],
    quantityPerPack: 26,
    translationKeys: {
      shortHand: 'productSizes.p6.shortHand',
      lowerCaseName: 'productSizes.p6.lowerCaseName'
    }
  }
]

export const DIAPERS_SIZES = SIZES_DATA.filter((size) => {
  return DIAPERS_PRODUCT_TYPE.sizes.includes(size.id)
})
export const PANTS_SIZES = SIZES_DATA.filter((size) => {
  return PANTS_PRODUCT_TYPE.sizes.includes(size.id)
})

export const PATTERNS_DATA = [
  {
    id: 'malo',
    skuPart: 'ML',
    category: 'permanent',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_motif_malo.png',
      pants:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_culotte_motif_malo.png'
    },
    translationKeys: {
      name: 'patterns.malo.name',
      imageAlt: {
        diapers: 'patterns.malo.diapersImageAlt',
        pants: 'patterns.malo.pantsImageAlt'
      }
    }
  },
  {
    id: 'brigitte',
    skuPart: 'RC',
    category: 'permanent',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_motif_brigitte.png',
      pants:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_culotte_motif_brigitte.png'
    },
    translationKeys: {
      name: 'patterns.brigitte.name',
      imageAlt: {
        diapers: 'patterns.brigitte.diapersImageAlt',
        pants: 'patterns.brigitte.pantsImageAlt'
      }
    }
  },
  {
    id: 'blanc',
    skuPart: 'BL',
    category: 'permanent',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_blanche.png'
    },
    translationKeys: {
      name: 'patterns.blanc.name',
      imageAlt: {
        diapers: 'patterns.blanc.diapersImageAlt',
        pants: 'patterns.blanc.pantsImageAlt'
      }
    }
  },
  {
    id: 'william',
    skuPart: 'HIP',
    category: 'new',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_motif_william.png'
    },
    translationKeys: {
      name: 'patterns.william.name',
      imageAlt: {
        diapers: 'patterns.william.diapersImageAlt',
        pants: 'patterns.william.pantsImageAlt'
      }
    }
  },
  {
    id: 'andrea',
    skuPart: 'AND',
    category: 'new',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_motif_andrea.png'
    },
    translationKeys: {
      name: 'patterns.andrea.name',
      imageAlt: {
        diapers: 'patterns.andrea.diapersImageAlt',
        pants: 'patterns.andrea.pantsImageAlt'
      }
    }
  },
  {
    id: 'odette',
    skuPart: 'P',
    category: 'season',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_motif_odette.png'
    },
    translationKeys: {
      name: 'patterns.odette.name',
      imageAlt: {
        diapers: 'patterns.odette.diapersImageAlt',
        pants: 'patterns.odette.pantsImageAlt'
      }
    }
  },
  {
    id: 'barbara',
    skuPart: 'BAR',
    category: 'season',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_motif_barbara.png',
      pants:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_culotte_motif_barbara.png'
    },
    translationKeys: {
      name: 'patterns.barbara.name',
      imageAlt: {
        diapers: 'patterns.barbara.diapersImageAlt',
        pants: 'patterns.barbara.pantsImageAlt'
      }
    }
  },
  {
    id: 'bernard',
    skuPart: 'BE',
    category: 'season',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_motif_bernard.png',
      pants:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_culotte_motif_bernard.png'
    },
    translationKeys: {
      name: 'patterns.bernard.name',
      imageAlt: {
        diapers: 'patterns.bernard.diapersImageAlt',
        pants: 'patterns.bernard.pantsImageAlt'
      }
    }
  },
  {
    id: 'leon',
    skuPart: 'LE',
    category: 'season',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_motif_leon.png'
    },
    translationKeys: {
      name: 'patterns.leon.name',
      imageAlt: {
        diapers: 'patterns.leon.diapersImageAlt',
        pants: 'patterns.leon.pantsImageAlt'
      }
    }
  },
  {
    id: 'gabriel',
    skuPart: 'GAB',
    category: 'new',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/1956/4693/files/gabriel_rectangle.png'
    },
    translationKeys: {
      name: 'patterns.gabriel.name',
      imageAlt: {
        diapers: 'patterns.gabriel.diapersImageAlt',
        pants: 'patterns.gabriel.pantsImageAlt'
      }
    }
  },
  {
    id: 'marceau',
    skuPart: 'MANO',
    category: 'new',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/couche_motif_marceau.png'
    },
    translationKeys: {
      name: 'patterns.marceau.name',
      imageAlt: {
        diapers: 'patterns.marceau.diapersImageAlt',
        pants: 'patterns.marceau.pantsImageAlt'
      }
    }
  },
  {
    id: 'edmond',
    skuPart: 'ED',
    category: 'new',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_motif_edmond.jpg'
    },
    translationKeys: {
      name: 'patterns.edmond.name',
      imageAlt: {
        diapers: 'patterns.edmond.diapersImageAlt',
        pants: 'patterns.edmond.pantsImageAlt'
      }
    }
  },
  {
    id: 'oscar',
    skuPart: 'OSC',
    category: 'new',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_motif_oscar.png?v=1694521820'
    },
    translationKeys: {
      name: 'patterns.oscar.name',
      imageAlt: {
        diapers: 'patterns.oscar.diapersImageAlt',
        pants: 'patterns.oscar.pantsImageAlt'
      }
    }
  },
  {
    id: 'tribudenoel',
    skuPart: 'TNO',
    category: 'new',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_motif_tno.png?v=1699369897'
    },
    translationKeys: {
      name: 'patterns.tribudenoel.name',
      imageAlt: {
        diapers: 'patterns.tribudenoel.diapersImageAlt',
        pants: 'patterns.tribudenoel.pantsImageAlt'
      }
    }
  },
  {
    id: 'benoit',
    skuPart: 'BEN',
    category: 'new',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_motif_benoit.png?v=1709717097'
    },
    translationKeys: {
      name: 'patterns.benoit.name',
      imageAlt: {
        diapers: 'patterns.benoit.diapersImageAlt',
        pants: 'patterns.benoit.pantsImageAlt'
      }
    }
  },
  {
    id: 'minischampions',
    skuPart: 'ATH',
    category: 'new',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_motif_petitschampions.png?v=1717494978'
    },
    translationKeys: {
      name: 'patterns.minischampions.name',
      imageAlt: {
        diapers: 'patterns.minischampions.diapersImageAlt',
        pants: 'patterns.minischampions.pantsImageAlt'
      }
    }
  },
  {
    id: 'gaston',
    skuPart: 'GAS',
    category: 'new',
    imageSources: {
      diapers:
        'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_motif_gaston.png?v=1724853609'
    },
    translationKeys: {
      name: 'patterns.gaston.name',
      imageAlt: {
        diapers: 'patterns.gaston.diapersImageAlt',
        pants: 'patterns.gaston.pantsImageAlt'
      }
    }
  }
]

export const DIAPERS_PATTERNS = PATTERNS_DATA.filter((pattern) => {
  return DIAPERS_PRODUCT_TYPE.patterns.includes(pattern.id)
})
export const PANTS_PATTERNS = PATTERNS_DATA.filter((pattern) => {
  return PANTS_PRODUCT_TYPE.patterns.includes(pattern.id)
})

export const UPSELLS_DATA = [
  {
    id: 'liniment',
    skuPart: 'S',
    variants: [
      {
        id: 'base-liniment',
        upgradeData: {
          sku: 'LM1.IDV',
          price: 9.9,
          quantity: 1
        },
        upsellData: {
          sku: 'LM4.IDV',
          price: 11.9,
          quantity: 1
        },
        imageSource:
          'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/liniment_joone.png',
        translationKeys: {
          imageAlt: 'upsells.liniment.imageAlt'
        }
      }
    ],
    translationKeys: {
      name: 'upsells.liniment.name',
      description: 'upsells.liniment.description',
      tooltipText: 'upsells.liniment.tooltipText'
    }
  },
  {
    id: 'wash',
    skuPart: 'S',
    variants: [
      {
        id: 'base-wash',
        upgradeData: {
          sku: 'LAV.IDV',
          price: 9.9,
          quantity: 1
        },
        upsellData: {
          sku: 'LAV4.IDV',
          price: 11.9,
          quantity: 1
        },
        imageSource:
          'https://cdn.shopify.com/s/files/1/0376/6835/6232/files/gel_lavant_joone.png',
        translationKeys: {
          imageAlt: 'upsells.wash.imageAlt'
        }
      }
    ],
    translationKeys: {
      name: 'upsells.wash.name',
      description: 'upsells.wash.description',
      tooltipText: 'upsells.wash.tooltipText'
    }
  },
  {
    id: 'cottons',
    skuPart: 'P',
    variants: [
      {
        id: 'base-cottons',
        upgradeData: {
          sku: 'COTON.A.BB.200.IDV',
          price: 5.9,
          quantity: 1
        },
        upsellData: {
          sku: 'COTON.BB.200.IDV',
          price: 5.9,
          quantity: 1
        },
        imageSource:
          'https://cdn.shopify.com/s/files/1/1956/4693/files/COTON.BB.200_EC.png',
        translationKeys: {
          imageAlt: 'upsells.cottons.imageAlt'
        }
      }
    ],
    translationKeys: {
      name: 'upsells.cottons.name',
      description: 'upsells.cottons.description',
      tooltipText: 'upsells.cottons.tooltipText'
    }
  },
  {
    id: 'wipes',
    skuPart: 'W',
    variants: [
      {
        id: 'water-wipes',
        upgradeData: {
          sku: 'L5E.50.IDV',
          price: 5.0,
          quantity: 1
        },
        upsellData: {
          sku: 'L5E.50.IDV',
          price: 7.9,
          quantity: 1
        },
        imageSource:
          'https://cdn.shopify.com/s/files/1/1956/4693/files/lingettes_compostables_joone.png?v=1707300268',
        translationKeys: {
          optionName: 'upsells.wipes.options.water',
          imageAlt: 'upsells.wipes.imageAlt'
        }
      }
    ],
    translationKeys: {
      name: 'upsells.wipes.name',
      description: 'upsells.wipes.description',
      tooltipText: 'upsells.wipes.tooltipText'
    }
  }
]

export const BAB_DATA = {
  steps: STEPS_DATA,
  productTypes: PRODUCT_TYPES_DATA,
  bundles: BUNDLES_DATA,
  sizes: SIZES_DATA,
  patterns: PATTERNS_DATA,
  upsells: UPSELLS_DATA
}

export function regexSkuMatching (skuBase, patternSkuPart, sizeSkuPart) {
  return new RegExp(`${skuBase}(.AB|.IDV|).${patternSkuPart}(.PE|.IDV|).${sizeSkuPart}`)
}
